export interface Video {
  id: string;
  title: string;
  cover: string;
  category: string;
  score: number;
  year: string;
  region: string;
  description: string;
  isHot: boolean;
  isNew: boolean;
  actors: string;
  director: string;
  episodeInfo: string;
  updateDate: string;
}

export const videos: Video[] = [
  {
    id: "v001",
    title: "流浪地球2",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20style%20with%20futuristic%20spaceship%20and%20earth%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20background%20with%20orange%20glow%2C%20professional%20film%20poster%20design%2C%20clean%20minimal%20background%20with%20subtle%20gradient%2C%20movie%20poster%20template%20layout%20with%20title%20area&width=600&height=800&seq=movie-scifi-01&orientation=portrait",
    category: "movie",
    score: 8.3,
    year: "2023",
    region: "中国大陆",
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。",
    isHot: true,
    isNew: false,
    actors: "吴京 / 刘德华 / 李雪健",
    director: "郭帆",
    episodeInfo: "HD高清",
    updateDate: "2026-07-25",
  },
  {
    id: "v002",
    title: "满江红",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%20with%20ancient%20palace%20courtyard%20atmosphere%2C%20warm%20red%20lantern%20lighting%2C%20traditional%20Chinese%20aesthetic%2C%20cinematic%20film%20poster%20design%2C%20dark%20moody%20background%20with%20candlelight%20glow&width=600&height=800&seq=movie-hist-02&orientation=portrait",
    category: "movie",
    score: 7.5,
    year: "2023",
    region: "中国大陆",
    description: "南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相府邸，所携密信也不翼而飞。小兵张大与亲兵营副统领孙均机缘巧合被裹挟进巨大阴谋之中。",
    isHot: true,
    isNew: false,
    actors: "沈腾 / 易烊千玺 / 张译",
    director: "张艺谋",
    episodeInfo: "HD高清",
    updateDate: "2026-07-20",
  },
  {
    id: "v003",
    title: "狂飙",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20TV%20drama%20poster%20with%20intense%20atmosphere%2C%20dark%20alley%20with%20neon%20lights%2C%20police%20and%20gangster%20theme%2C%20dramatic%20cinematic%20composition%2C%20professional%20drama%20series%20poster%20design&width=600&height=800&seq=tv-crime-03&orientation=portrait",
    category: "tv",
    score: 8.5,
    year: "2023",
    region: "中国大陆",
    description: "京海市一线刑警安欣，在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海。",
    isHot: true,
    isNew: false,
    actors: "张译 / 张颂文 / 李一桐",
    director: "徐纪周",
    episodeInfo: "更新至39集",
    updateDate: "2026-07-28",
  },
  {
    id: "v004",
    title: "三体",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20with%20three%20suns%20in%20space%2C%20mysterious%20cosmic%20atmosphere%2C%20dark%20universe%20background%20with%20stars%2C%20dramatic%20and%20philosophical%20tone%2C%20professional%20series%20poster%20design&width=600&height=800&seq=tv-scifi-04&orientation=portrait",
    category: "tv",
    score: 8.1,
    year: "2023",
    region: "中国大陆",
    description: "纳米科学家汪淼被警官史强带到联合作战中心，潜入科学边界组织协助调查。在接触了名为三体的游戏后，汪淼发现了外星文明的秘密。",
    isHot: false,
    isNew: true,
    actors: "张鲁一 / 于和伟 / 陈瑾",
    director: "杨磊",
    episodeInfo: "更新至30集",
    updateDate: "2026-08-01",
  },
  {
    id: "v005",
    title: "奔跑吧·第12季",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20colorful%20playful%20vibe%2C%20outdoor%20running%20and%20games%20theme%2C%20bright%20sunny%20atmosphere%2C%20energetic%20group%20photo%20style%2C%20entertainment%20show%20poster%20design&width=600&height=800&seq=variety-run-05&orientation=portrait",
    category: "variety",
    score: 7.2,
    year: "2026",
    region: "中国大陆",
    description: "国民综艺《奔跑吧》第十二季热血回归！新老成员集结，花样游戏挑战全面升级，欢乐与感动继续。",
    isHot: false,
    isNew: true,
    actors: "李晨 / 郑恺 / 沙溢",
    director: "姚译添",
    episodeInfo: "更新至第8期",
    updateDate: "2026-08-01",
  },
  {
    id: "v006",
    title: "斗罗大陆II",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20anime%20poster%20with%20martial%20arts%20fantasy%20theme%2C%20young%20hero%20with%20glowing%20spirit%20rings%2C%20beautiful%20landscape%20with%20magical%20elements%2C%20vibrant%20colors%20and%20dynamic%20action%20pose%2C%20animation%20series%20poster&width=600&height=800&seq=anime-soul-06&orientation=portrait",
    category: "anime",
    score: 8.7,
    year: "2026",
    region: "中国大陆",
    description: "唐门外门弟子唐三，因偷学内门绝学为唐门所不容，跳崖明志时却来到了另一个世界——斗罗大陆。在这里他开启了一段传奇的魂师修炼之旅。",
    isHot: true,
    isNew: false,
    actors: "配音阵容",
    director: "沈乐平",
    episodeInfo: "更新至285集",
    updateDate: "2026-08-02",
  },
  {
    id: "v007",
    title: "封神第一部",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20epic%20fantasy%20movie%20poster%20with%20ancient%20Chinese%20mythology%20theme%2C%20warriors%20in%20armor%2C%20dramatic%20battle%20scene%20atmosphere%2C%20golden%20and%20crimson%20color%20scheme%2C%20grand%20cinematic%20composition&width=600&height=800&seq=movie-epic-07&orientation=portrait",
    category: "movie",
    score: 7.8,
    year: "2023",
    region: "中国大陆",
    description: "殷商末年，狐妖妲己祸乱朝纲，天下大乱。姬发觉醒，率众反抗暴政，封神大战一触即发。",
    isHot: false,
    isNew: false,
    actors: "费翔 / 李雪健 / 黄渤",
    director: "乌尔善",
    episodeInfo: "HD高清",
    updateDate: "2026-06-15",
  },
  {
    id: "v008",
    title: "庆余年·第二季",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20TV%20poster%20with%20ancient%20palace%20background%2C%20intellectual%20and%20witty%20male%20protagonist%2C%20elegant%20traditional%20Chinese%20aesthetic%2C%20soft%20golden%20lighting%2C%20premium%20series%20poster%20design&width=600&height=800&seq=tv-celebrate-08&orientation=portrait",
    category: "tv",
    score: 8.9,
    year: "2024",
    region: "中国大陆",
    description: "范闲历经家族、江湖、庙堂的种种考验与锤炼，书写了光彩夺目的人生传奇。第二季中，他将面临更大的挑战与更深的阴谋。",
    isHot: true,
    isNew: true,
    actors: "张若昀 / 李沁 / 陈道明",
    director: "孙皓",
    episodeInfo: "更新至36集",
    updateDate: "2026-08-02",
  },
  {
    id: "v009",
    title: "熊出没·逆转时空",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20with%20two%20bears%20in%20forest%20adventure%20theme%2C%20colorful%20and%20fun%20style%2C%20bright%20natural%20background%2C%20family-friendly%203D%20animation%20aesthetic%2C%20children%20movie%20poster%20design&width=600&height=800&seq=anime-bear-09&orientation=portrait",
    category: "anime",
    score: 7.6,
    year: "2024",
    region: "中国大陆",
    description: "光头强和熊大、熊二意外获得了穿越时空的能力，他们将在不同的时代中展开一段奇妙的冒险旅程。",
    isHot: false,
    isNew: true,
    actors: "配音阵容",
    director: "丁亮",
    episodeInfo: "HD高清",
    updateDate: "2026-07-30",
  },
  {
    id: "v010",
    title: "向往的生活·第8季",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20lifestyle%20variety%20show%20poster%20with%20peaceful%20countryside%20farm%20setting%2C%20warm%20sunset%20lighting%2C%20cozy%20rural%20house%20with%20garden%2C%20relaxed%20and%20natural%20atmosphere%2C%20entertainment%20show%20poster%20design&width=600&height=800&seq=variety-life-10&orientation=portrait",
    category: "variety",
    score: 7.8,
    year: "2026",
    region: "中国大陆",
    description: "黄磊、何炅携手新老好友回归田园慢生活，做饭、聊天、劳作，感受最简单纯粹的幸福时光。",
    isHot: false,
    isNew: false,
    actors: "黄磊 / 何炅 / 张艺兴",
    director: "王征宇",
    episodeInfo: "更新至第10期",
    updateDate: "2026-07-22",
  },
  {
    id: "v011",
    title: "孤注一掷",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%20with%20dark%20mysterious%20atmosphere%2C%20city%20night%20scene%20with%20red%20neon%2C%20suspenseful%20tone%2C%20gambling%20and%20conspiracy%20theme%2C%20intense%20cinematic%20poster%20design&width=600&height=800&seq=movie-thrill-11&orientation=portrait",
    category: "movie",
    score: 7.1,
    year: "2023",
    region: "中国大陆",
    description: "程序员潘生和模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱。他们为了逃离，不得不铤而走险。",
    isHot: false,
    isNew: false,
    actors: "张艺兴 / 金晨 / 王传君",
    director: "申奥",
    episodeInfo: "HD高清",
    updateDate: "2026-06-20",
  },
  {
    id: "v012",
    title: "莲花楼",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20wuxia%20drama%20TV%20poster%20with%20martial%20arts%20hero%20in%20ancient%20Chinese%20setting%2C%20mountain%20landscape%20background%2C%20flowing%20robes%20and%20sword%2C%20elegant%20and%20heroic%20composition%2C%20drama%20series%20poster&width=600&height=800&seq=tv-legend-12&orientation=portrait",
    category: "tv",
    score: 8.4,
    year: "2023",
    region: "中国大陆",
    description: "该剧改编自藤萍的小说《吉祥纹莲花楼》，讲述了闻名武林的四顾门门主李相夷在一次大战后身受重伤，隐退成为淡泊名利的郎中李莲花的故事。",
    isHot: false,
    isNew: true,
    actors: "成毅 / 曾舜晞 / 肖顺尧",
    director: "郭虎",
    episodeInfo: "更新至40集",
    updateDate: "2026-07-29",
  },
];

export const getVideosByCategory = (category: string): Video[] => {
  return videos.filter((v) => v.category === category);
};

export const getHotVideos = (): Video[] => {
  return videos.filter((v) => v.isHot);
};

export const getNewVideos = (): Video[] => {
  return videos.filter((v) => v.isNew);
};

export const getVideoById = (id: string): Video | undefined => {
  return videos.find((v) => v.id === id);
};